var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDietLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64.985,
    viewBox: "0 0 65 64.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5231",
    "data-name": "Group 5231",
    transform: "translate(-13865 -661.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M313,338v6.1c0,4.778,1.826,12.327,8.044,13.129L319.1,378.645",
    transform: "translate(13572.306 346.788)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M337.128,341v3.048c0,4.737-2.682,12.208-8.045,13.117l1.948,21.431",
    transform: "translate(13572.564 346.836)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x2: 2.032,
    transform: "translate(13899.531 704.094)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    y2: 8.129,
    transform: "translate(13893.435 685.804)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    y2: 7.113,
    transform: "translate(13901.563 686.82)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M328.548,335.489l-1.6-4.292-1.159,4.02-.3-.017-20.5-2.4c-5.786-.873-10.883-2.076-10.983-5.621V326.16c.1-4.336,5.191-4.746,10.983-5.622l7.035-1.233.063.062,1.785,3.78.98-4.056.068-.106,19.973-2.213.1.051,2.02,4.312.747-4.584-.012-.091,2.821-.317c5.677-.544,10.335,4.558,10.339,10.179v.661c0,5.615-4.561,10.941-10.339,10.175l-12.016-1.621Z",
    transform: "translate(13572 346.435)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M352.032,324H356.1a5.7,5.7,0,0,0,0,4.065H350",
    transform: "translate(13572.903 346.562)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M353.977,329.2a20.963,20.963,0,0,0-.913,3.865L349,332.045",
    transform: "translate(13572.887 346.646)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M354.081,324.064A24.094,24.094,0,0,1,353.065,320L349,321.016",
    transform: "translate(13572.887 346.497)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    y2: 5.081,
    transform: "translate(13913.758 678.691)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    y2: 3.048,
    transform: "translate(13898.516 664.465)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    y2: 3.048,
    transform: "translate(13876.16 675.643)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietLevel);
export default __webpack_public_path__ + "static/media/diet-level.5114c25734335d3a50775e9a140796fe.svg";
export { ForwardRef as ReactComponent };